import { PropsWithChildren } from "react";
import { ProductImageDetailsRootScreenContext } from "../../utilities/product-image-details-root";

export type ProductImageDetailsRootProviderProps = PropsWithChildren<{
  productId: string;
}>;

export function ProductImageDetailsRootProvider({
  productId,
  children,
}: ProductImageDetailsRootProviderProps) {
  return (
    <ProductImageDetailsRootScreenContext.Provider value={{ productId }}>
      {children}
    </ProductImageDetailsRootScreenContext.Provider>
  );
}
